/**
 * Default axios timeout for Sensemaker HTTP calls.
 * Without this, a down / unreachable proxied service can leave `/` stuck on the auth spinner.
 */
export const API_REQUEST_TIMEOUT_MS = 60_000

/**
 * Campaign step completion that chains AI HTTP (research goal + clarifying questions, or LoI).
 * Must exceed campaign-service `AI_HTTP_TIMEOUT_MS` (120s) × sequential calls + buffer.
 */
export const CAMPAIGN_AI_REQUEST_TIMEOUT_MS = 260_000

/** Question drill-down AI findings (cross-tab + interpretation) — may chain two AI HTTP calls. */
export const QUESTION_AI_FINDINGS_TIMEOUT_MS = 150_000
